export const INTAKE_FORM_V1_SWITCH = 'provider_intake_forms_v1_enabled_com1546_20240513';
